import propTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { addCoupon } from '../../actions/coupon';

const AddCoupon = ({
    addCoupon,
    auth
}) => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        roomtype: '',
        discount: '',
        minduration: '',
        couponcode: ''
    })

    const {
        roomtype,
        discount,
        minduration,
        couponcode
    } = formData;

    const onChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = (e) => {
        e.preventDefault();
        addCoupon(formData, navigate);
    };
  
    return (
        <div className='container' style={{maxWidth: "650px"}}>
        <Card border="warning">
            <Card.Header>Enter Coupon Information</Card.Header>
            <Card.Body>
                <form style={{ textAlign: "center" }} className="form" onSubmit={ e => onSubmit(e)}>

                    <label>Coupon Code
                        <input type='text' placeholder='Coupon Code' name="couponcode" value={couponcode} required onChange={e => onChange(e)} />
                    </label>

                    <label>Discount %
                        <select id="discount" name="discount" value={discount} size="1" required onChange={e => onChange(e)}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={15}>15</option>
                            <option value={20}>20</option>
                            <option value={25}>25</option>
                            <option value={30}>30</option>
                        </select>
                    </label>

                    <label>Coupon Type
                        <select id="roomtype" name="roomtype" value={roomtype} size="1" required onChange={e => onChange(e)}>
                            <option value={"Deluxe Double Bed"}>Deluxe Double Bed</option>
                            <option value={"Non-Deluxe Double Bed"}>Non-Deluxe Double Bed</option>
                            <option value={"Suite"}>Suite</option>
                            <option value={"Couple"}>Couple</option>
                            <option value={"Twin Double Bed"}>Twin Double Bed</option>
                            <option value={"Twin Single Bed"}>Twin Singe Bed</option>
                            <option value={"Bar"}>Bar</option>
                            <option value={"Conference"}>Conference</option>
                        </select>
                    </label>

                    <label>Minimum Duration
                        <select id="minduration" name="minduration" value={minduration} size="1" required onChange={e => onChange(e)}>
                            <option value={1}>1 Day</option>
                            <option value={2}>2 Days</option>
                            <option value={3}>3 Days</option>
                            <option value={4}>4 Days</option>
                            <option value={5}>5 Days</option>
                            <option value={6}>6 Days</option>
                            <option value={7}>7 Days</option>
                            <option value={8}>8 Days</option>
                            <option value={9}>9 Days</option>
                            <option value={10}>10 Days</option>
                        </select>
                    </label>
                    <br />
                
                    <input type="submit" className="btn btn-success" value="Add Coupon" /> 
                </form>
            </Card.Body>
        </Card>
        </div>
    )
}

AddCoupon.propTypes = {
  addCoupon: propTypes.func.isRequired,
  auth: propTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { addCoupon })(AddCoupon);